"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardImageLong = void 0;
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _Typography = require("../Typography");
var _helpers = require("../../common/helpers");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["as", "preHeading", "heading", "description", "image", "noAction", "slots", "slotProps", "className"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"],
  _excluded8 = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var classesRoot = (0, _classVarianceAuthority.cva)(['group', 'flex', 'flex-col', 'gap-4', 'md:flex-row', 'md:gap-8', 'w-full', 'rounded-xl', 'md:shadow', 'md:bg-gray-50', 'duration-200', 'transition-shadow'], {
  variants: {
    noAction: {
      "true": ['outline-primary', 'outline-offset-2', 'focus:outline-2'],
      "false": ['md:hover:shadow-md']
    }
  }
});

/*
 * Note: Width full and aspect ratio together will prevent content layout shift.
 * Object cover seemed like a sensible default; but can be overriden with slot props.
 */
var classesImage = (0, _classVarianceAuthority.cva)(['scale-100', 'duration-200', 'w-full', 'object-cover', 'origin-center', 'duration-200', 'aspect-4/3', 'md:min-w-[286px]', 'md:w-[286px]'], {
  variants: {
    noAction: {
      "true": [],
      "false": ['group-hover:scale-105']
    }
  }
});

/**
 * Card Image Long - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/surfaces-cardimagelong) | [DSM](https://sharphealthcare.notion.site/Card-image-long-item-8d1fb560419d4fa6a31999385eb9259a)
 *
 * @example
 *
 * <CardImageLong
 *  heading="Example 1"
 *  description="With custom image component"
 *  image={{ src: 'image.jpg' }}
 *  href="/" />
 *
 * <CardImageLong
 *  heading="Example 2"
 *  description="With no action"
 *  image={{ src: 'image.jpg' }}
 *  noAction />
 */
var CardImageLong = exports.CardImageLong = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _slots$imageContainer, _slotProps$imageConta, _slots$image, _slotProps$image, _slots$contentContain, _slotProps$contentCon, _slots$preHeading, _slotProps$preHeading, _slots$heading, _slotProps$heading, _slots$description, _slotProps$descriptio, _slotProps$preHeading2, _slotProps$descriptio2;
  var _props$as = props.as,
    Root = _props$as === void 0 ? 'a' : _props$as,
    preHeading = props.preHeading,
    heading = props.heading,
    description = props.description,
    _props$image = props.image,
    image = _props$image === void 0 ? {} : _props$image,
    _props$noAction = props.noAction,
    noAction = _props$noAction === void 0 ? false : _props$noAction,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var ImageContainer = (_slots$imageContainer = slots.imageContainer) !== null && _slots$imageContainer !== void 0 ? _slots$imageContainer : 'div';
  var _ref = (_slotProps$imageConta = slotProps === null || slotProps === void 0 ? void 0 : slotProps.imageContainer) !== null && _slotProps$imageConta !== void 0 ? _slotProps$imageConta : {},
    imageContainerSlotPropsClassName = _ref.className,
    imageContainerSlotProps = _objectWithoutProperties(_ref, _excluded2);
  var Image = (_slots$image = slots.image) !== null && _slots$image !== void 0 ? _slots$image : 'img';
  var imagePropClassName = image.className,
    imagePropProps = _objectWithoutProperties(image, _excluded3);
  var _ref2 = (_slotProps$image = slotProps.image) !== null && _slotProps$image !== void 0 ? _slotProps$image : {},
    imageSlotPropsClassName = _ref2.className,
    imageSlotProps = _objectWithoutProperties(_ref2, _excluded4);
  var imageProps = slots.image ? imageSlotProps : _objectSpread(_objectSpread({}, imagePropProps), imageSlotProps);
  var ContentContainer = (_slots$contentContain = slots.contentContainer) !== null && _slots$contentContain !== void 0 ? _slots$contentContain : 'div';
  var _ref3 = (_slotProps$contentCon = slotProps.contentContainer) !== null && _slotProps$contentCon !== void 0 ? _slotProps$contentCon : {},
    contentContainerSlotPropsClassName = _ref3.className,
    contentContainerSlotProps = _objectWithoutProperties(_ref3, _excluded5);
  var PreHeading = (_slots$preHeading = slots.preHeading) !== null && _slots$preHeading !== void 0 ? _slots$preHeading : _Typography.Typography;
  var _ref4 = (_slotProps$preHeading = slotProps.preHeading) !== null && _slotProps$preHeading !== void 0 ? _slotProps$preHeading : {},
    preHeadingSlotPropsClassName = _ref4.className,
    preHeadingSlotProps = _objectWithoutProperties(_ref4, _excluded6);
  // If preHeading slot provided then do not spread Typography specific props else combine
  var preHeadingProps = slots.preHeading ? preHeadingSlotProps : _objectSpread({
    variant: 'small-body-semibold'
  }, preHeadingSlotProps);
  var Heading = (_slots$heading = slots.heading) !== null && _slots$heading !== void 0 ? _slots$heading : _Typography.Typography;
  var _ref5 = (_slotProps$heading = slotProps.heading) !== null && _slotProps$heading !== void 0 ? _slotProps$heading : {},
    headingSlotPropsClassName = _ref5.className,
    headingSlotProps = _objectWithoutProperties(_ref5, _excluded7);
  // If heading slot provided then do not spread Typography specific props else combine
  var headingProps = slots.heading ? headingSlotProps : _objectSpread({
    variant: 'h3'
  }, headingSlotProps);
  var Description = (_slots$description = slots.description) !== null && _slots$description !== void 0 ? _slots$description : _Typography.Typography;
  var _ref6 = (_slotProps$descriptio = slotProps.description) !== null && _slotProps$descriptio !== void 0 ? _slotProps$descriptio : {},
    descriptionSlotPropsClassName = _ref6.className,
    descriptionSlotProps = _objectWithoutProperties(_ref6, _excluded8);
  // If description slot provided then do not spread Typography specific props else combine
  var descriptionProps = slots.description ? descriptionSlotProps : _objectSpread({
    variant: 'small-body'
  }, descriptionSlotProps);
  var hasPreHeading = preHeading !== null && preHeading !== void 0 ? preHeading : (_slotProps$preHeading2 = slotProps.preHeading) === null || _slotProps$preHeading2 === void 0 ? void 0 : _slotProps$preHeading2.children;
  var hasDescription = description !== null && description !== void 0 ? description : (_slotProps$descriptio2 = slotProps.description) === null || _slotProps$descriptio2 === void 0 ? void 0 : _slotProps$descriptio2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: (0, _helpers.cn)(classesRoot({
      noAction: noAction
    }), className),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ImageContainer, _objectSpread(_objectSpread({
      className: (0, _helpers.cn)('rounded-xl md:rounded-r-none overflow-hidden flex-shrink-0', imageContainerSlotPropsClassName)
    }, imageContainerSlotProps), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Image, _objectSpread({
        className: (0, _helpers.cn)(classesImage({
          noAction: noAction
        }), imageSlotPropsClassName)
      }, imageProps))
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ContentContainer, _objectSpread(_objectSpread({
      className: (0, _helpers.cn)('flex flex-col gap-2 justify-center md:pr-8', contentContainerSlotPropsClassName)
    }, contentContainerSlotProps), {}, {
      children: [hasPreHeading && /*#__PURE__*/(0, _jsxRuntime.jsx)(PreHeading, _objectSpread(_objectSpread({
        className: (0, _helpers.cn)('text-left md:line-clamp-1', preHeadingSlotPropsClassName)
      }, preHeadingProps), {}, {
        children: preHeading
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(Heading, _objectSpread(_objectSpread({
        className: (0, _helpers.cn)('text-left md:line-clamp-2', !noAction && 'group-hover:underline', headingSlotPropsClassName)
      }, headingProps), {}, {
        children: heading
      })), hasDescription && /*#__PURE__*/(0, _jsxRuntime.jsx)(Description, _objectSpread(_objectSpread({
        className: (0, _helpers.cn)('text-left', hasPreHeading && 'md:line-clamp-3', !hasPreHeading && 'md:line-clamp-4', descriptionSlotPropsClassName)
      }, descriptionProps), {}, {
        children: description
      }))]
    }))]
  }));
});